import React, { useState } from 'react'
import Header from '../Header'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import moment from "moment"
import OTPPopup from './CrifOTPPopup';
import Loader from '../common/Loader'
import CrifReportPage from './CrifReportPage';
import { panRegex, indianStates } from '../../Utils/Constants';
import { SendAMUOTP } from '../../Access/ActionCreator';
import AlertPopup from '../common/AlertPopup';

export default function CrifPageMain({ PageHandler }) {
    const [loader, setLoader] = useState(false)
    const [viewType, setViewType] = useState("InputForm")
    // const [viewType, setViewType] = useState("crifReport")
    const [showOTPPopup, setShowOTPPopup] = useState(false)
    const [SearchData, setSearchData] = useState({
        firstName: '',
        lastName: '',
        middleName: '',
        emailId: '',
        dateOfBirth: moment(new Date()).format('YYYY-MM-DD'),
        panNumber: '',
        mobileNumber: '',
        loanAmount: '',
        city: '',
        state: '',
        pincode: '',
        address: '',
        accountNumber: '',
        dealerName: '',
        dealerLocation: '',

    })
    const [errors, setErrors] = useState({})
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [shakeFields, setShakeFields] = useState([]);
    const [popup,setPopup] =useState({
        show:false,
        severity:"",
        message:"",
    })
    const inputFields = [
        { name: 'firstName', label: "First Name", type: 'text', value: SearchData.firstName, placeholder: "Enter First Name", required: true },
        { name: 'middleName', label: "Middle Name", type: 'text', value: SearchData.middleName, placeholder: "Enter Middle Name", required: false },
        { name: 'lastName', label: "Last Name", type: 'text', value: SearchData.lastName, placeholder: "Enter Last Name", required: true },
        { name: 'emailId', label: "Email Id", type: 'email', value: SearchData.emailId, placeholder: "Select Email", required: true },
        { name: 'dateOfBirth', label: "D.O.B", type: 'date', value: SearchData.dateOfBirth, placeholder: "Select DOB", required: true },
        { name: 'panNumber', label: "PAN Number", type: 'text', value: SearchData.panNumber, placeholder: "Enter PAN", required: true },
        { name: 'mobileNumber', label: "Mobile Number", type: 'number', value: SearchData.mobileNumber, placeholder: "Enter Mobile Number", required: true },
        { name: 'accountNumber', label: "Account Number", type: 'number', value: SearchData.accountNumber, placeholder: "Enter Account Number", required: true },
        { name: 'loanAmount', label: "Loan Amount", type: 'number', value: SearchData.loanAmount, placeholder: "Enter Loan Amount", required: true },
        { name: 'address', label: "Address", type: 'text', value: SearchData.address, placeholder: "Enter Address", required: true },
        { name: 'city', label: "City", type: 'text', value: SearchData.city, placeholder: "Enter City", required: true },
        { name: 'state', label: "State", type: 'text', value: SearchData.state, placeholder: "Enter State", required: true },
        { name: 'pincode', label: "Pincode", type: 'number', value: SearchData.pincode, placeholder: "Enter Pincode", required: true },
        { name: 'dealerName', label: "Dealer Name", type: 'text', value: SearchData.dealerName, placeholder: "Enter Dealer Name", required: false },
        { name: 'dealerLocation', label: "Dealer Location", type: 'text', value: SearchData.dealerLocation, placeholder: "Enter Dealer Location", required: false },
    ]


    const handleInputValues = (e) => {
        const { name, value } = e.target;
        setSearchData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const validateForm = () => {
        let formErrors = {};
        let fieldsToShake = [];

        if (!SearchData.firstName) {
            formErrors.firstName = 'First Name is required';
            fieldsToShake.push('firstName');
        }
        if (!SearchData.lastName) {
            formErrors.lastName = 'Last Name is required';
            fieldsToShake.push('lastName');
        }
        if (!SearchData.emailId) {
            formErrors.emailId = 'Email is required';
            fieldsToShake.push('emailId');
        }
        if (!SearchData.dateOfBirth) {
            formErrors.dateOfBirth = 'Date of Birth is required';
            fieldsToShake.push('dateOfBirth');
        }
        if (!SearchData.panNumber || !panRegex.test(SearchData.panNumber)) {
            formErrors.panNumber = 'Enter a valid PAN number';
            fieldsToShake.push('panNumber');
        }
        if (!SearchData.mobileNumber || SearchData.mobileNumber.length !== 10) {
            formErrors.mobileNumber = 'Enter a valid 10-digit mobile number';
            fieldsToShake.push('mobileNumber');
        }
        if (!SearchData.accountNumber) {
            formErrors.accountNumber = 'Account Number is required';
            fieldsToShake.push('accountNumber');
        }
        if (!SearchData.loanAmount) {
            formErrors.loanAmount = 'Loan amount is required';
            fieldsToShake.push('loanAmount');
        }
        if (!SearchData.address) {
            formErrors.address = 'Address is required';
            fieldsToShake.push('address');
        }
        if (!SearchData.city) {
            formErrors.city = 'City is required';
            fieldsToShake.push('city');
        }
        if (!SearchData.state) {
            formErrors.state = 'State is required';
            fieldsToShake.push('state');
        }
        if (!SearchData.pincode || SearchData.pincode.length !== 6) {
            formErrors.pincode = 'Enter a valid 6-digit pincode';
            fieldsToShake.push('pincode');
        }
        // if (!SearchData.dealerName ) {
        //     formErrors.dealerName = 'Dealer Name is required';
        //     fieldsToShake.push('dealerName');
        // }
        // if (!SearchData.dealerLocation ) {
        //     formErrors.dealerLocation = 'Dealer Location is required';
        //     fieldsToShake.push('dealerLocation');
        // }

        setShakeFields(fieldsToShake);
        setErrors(formErrors);

        setTimeout(() => setShakeFields([]), 300);
        setTimeout(() => setErrors([]), 4000);
        return Object.keys(formErrors).length === 0;
    };


    const handleGenerateBtn = () => {
        if (validateForm()) {
            // setLoader(true)
            // getAMUCrifReport(SearchData,(callback)=>{
            //     setLoader(false)
            //     if(callback && callback == "success"){
            //         setLoader(true)
            //         if( window.sessionStorage.getItem("SearchData")){
            //             window.sessionStorage.removeItem("SearchData")
            //         }
            //         const newData = JSON.stringify(SearchData)
            //         window.sessionStorage.setItem("SearchData",newData)
            //         SendAMUOTP(SearchData.mobileNumber,(callback)=>{
            //             setLoader(false)
            //             console.log("cal",callback)
            //             if(callback && callback?.status ==200  && callback?.message== "success"){
            //                 setPopup({show:true,severity:"success",message:"OTP Send Successfully"})
            //                 setShowOTPPopup(true)
            //             }else{
            //                 setPopup({show:true,severity:"error",message:"Error: Please Try Again"})
            //             }
            //         })
                  
            //     }else{
            //         setPopup({show:true,severity:"error",message:"Error: Please Try Again"})
            //     }
            //     setTimeout(() => setPopup({show:false,severity:"",message:""}), 4000);
            // })

            // setLoader(true)
            if( window.sessionStorage.getItem("SearchData")){
                window.sessionStorage.removeItem("SearchData")
            }
            const newData = JSON.stringify(SearchData)
            window.sessionStorage.setItem("SearchData",newData)
            // SendAMUOTP(SearchData.mobileNumber,(callback)=>{
            //     setLoader(false)
            //     if(callback && callback?.status ==200  && callback?.message== "success"){
            //         setPopup({show:true,severity:"success",message:"OTP Send Successfully"})
            //         setShowOTPPopup(true)
            //     }else{
            //         setPopup({show:true,severity:"error",message:"Error: Please Try Again"})
            //     }
            //     setTimeout(() => setPopup({show:false,severity:"",message:""}), 4000);
            // })
            setViewType("crifReport")
        } 

        // else if (!isCheckboxChecked) {
        //     setErrors((prevErrors) => ({ ...prevErrors, checkbox: 'You must agree to the CRIF check' }));
        // }
    }

    const removeOTPPopup = (type) => {
        setShowOTPPopup(false)
        setViewType(type)
    }

    const BackHandler = () => {
        setViewType("InputForm")
    }

    return (
        <>
            <div className="Dashboard">
                <Header PageHandler={PageHandler} />

                {
                    loader ?
                        <Loader />
                        : ''}
                {
                    popup.show ?
                        <AlertPopup severity={popup.severity} message={popup.message}/>
                        : ''}
                {
                    viewType === "InputForm" ?
                        <>
                            <div className="Main-content">
                                <div className="container-fluid">
                                    <div className="MainBox">
                                        <h4>CRIF Analysis</h4>

                                        <div className="InputBox">
                                            <div className="row">
                                                {
                                                    inputFields?.map((value, index) => {
                                                        return (
                                                            <div className="col-sm-3" key={index}>
                                                                <div className={`grp ${shakeFields.includes(value.name) ? 'shake' : ''}`}>
                                                                    {
                                                                        value?.name !== "state" ?
                                                                            <TextField id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={value?.value} placeholder={value?.placeholder} required={value?.required} onChange={(e) => handleInputValues(e)} helperText={errors[value.name] || ''}
                                                                                error={!!errors[value.name]} />
                                                                            :
                                                                            <TextField id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={value?.value} placeholder={value?.placeholder} required={value?.required} onChange={(e) => handleInputValues(e)} helperText={errors[value.name] || ''}
                                                                                error={!!errors[value.name]} >
                                                                                {indianStates.map((option) => (
                                                                                    <MenuItem key={option.value} value={option.label}>
                                                                                        {option.label}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                {/* <div className="col-xs-12" style={{ marginTop: '15px' }}>
                                                    <FormControlLabel control={<Checkbox checked={isCheckboxChecked}
                                                        onChange={(e) => setIsCheckboxChecked(e.target.checked)} />} label="I consent to the CRIF check for my loan application." />
                                                    {errors.checkbox && <p style={{ color: 'red', fontSize: '12px' }}>{errors.checkbox}</p>}
                                                </div> */}

                                                <div className='col-xs-12' style={{ marginTop: '20px', textAlign: 'center' }}>
                                                    <Button variant="contained" onClick={() => handleGenerateBtn()}>Generate CRIF Report</Button>
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                showOTPPopup ?
                                    <OTPPopup removeOTPPopup={removeOTPPopup} />
                                    : ''}
                        </>
                        : ''}

                {
                    viewType === "crifReport" ?
                        <CrifReportPage BackHandler={BackHandler} />
                        : ''}


            </div>
        </>
    )
}
